<template>
  <section class="section" style="padding-top:70px;padding-bottom:50px;">
    <div class="content" style="font-size: 2em; margin: 0 auto; min-height: 600px;">
      <div class="main-text" style="margin-top: 30px;">Novidades em Breve</div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'
import logger from '../../logger'

export default {
  name: 'videos',
  props: ['type'],
  data () {
    return {
      title: null,
      html: null
    }
  },
  computed: {
    ...mapState(['user'])
  },
  async mounted () {
    if (!this.user) {
      this.$router.push('/')
      this.$store.commit('redirect', '/usuario')
      this.$store.commit('showLogin', true)
      return false
    }
    // await this.getPolicy(this.type)
    document.body.style.backgroundColor = '#f2f2f2'
  },
  async beforeRouteUpdate (to, from, next) {
    // await this.getPolicy(to.query.type)
    next()
  },
  methods: {
    async getPolicy (type) {
      try {
        // Title
        if (type === 'sell') this.title = 'Termos de Uso'
        else if (type === 'privacy') this.title = 'Política de Privacidade'
        else if (type === 'half') this.title = 'Política de Meia Entrada'
        // HTML
        const { data } = await axios.get(`${process.env.VUE_APP_API}/policy/${type}`)
        this.html = data
      } catch (error) {
        logger.error(error, this)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";
.main-text {
  padding: 20px;
  color: #2c2b2b;
  font-size: 30px;
  text-align: center;
  font-family:'Arial';
  width: 95%;
}
.section {
  margin-top: $menu-height;
  margin: 0px;
  padding: 0px;
  // min-height: 100vh;
}
.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 1000px;
}
.policy {
  margin: $menu-height auto 30px;
  max-width: $max-width;
  padding: $padding-mobile;

  .policy-title {
    font-size: 1.5em;
    color: $primary-color;
    margin: 10px 0 20px;
  }

  .policy-content {
    font-size: 0.98em;
    color: #333;
    text-align: justify;
  }
}

@media screen and (min-width: $desktop-width) {

  .policy {
    padding: $padding-desktop;
  }

}
</style>

<style lang="scss">
.policy-content {
  p {
    padding: 7px 0;
  }
  b {
    text-transform: uppercase;
    font-size: 1.1em;
  }
  ul {
    margin-left: 20px;
  }
  a {
    color: #007bff;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
